import {customElement, property} from 'lit/decorators.js';
import {FlywheelComponent} from '@gl/lit/lib/component.js';
import {ImmutableComponent} from '@gl/lit/components/mixins/immutable_component/index.js';
import type {Constructor} from '@gl/lit/types/classes.js';
import type {Model, Msg} from './architecture.js';
import {main} from './architecture.js';
import styles from './style.scss';
import '@gl/lit/components/base/button/index.js';

export const AUDIENCE_EXPORT_SNAPSHOT_ELEMENT_TAG = 'audience-export-snapshot';

/**
 * Description here; Audience Export Snapshot Button
 */
@customElement(AUDIENCE_EXPORT_SNAPSHOT_ELEMENT_TAG)
export default class AudienceExportSnapshot extends ImmutableComponent<
  Constructor<FlywheelComponent>,
  Model,
  Msg
>({component: FlywheelComponent, main}) {
  @property({attribute: 'audience-export-id', type: Number})
  audienceExportId = 0;

  @property({attribute: 'last-snapshot', type: String})
  lastSnapshot = '';

  @property({attribute: 'audience-active', type: Boolean})
  activeAudience = false;

  static get styles() {
    return [styles];
  }
}

declare global {
  interface HTMLElementTagNameMap {
    [AUDIENCE_EXPORT_SNAPSHOT_ELEMENT_TAG]: AudienceExportSnapshot;
  }
}
